import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";


export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  LogoutRequest: "[Request Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",

};

const initialAuthState = {
  token: undefined,
  user: undefined,
  permissionList:[],
  name: undefined,
  surname:undefined,
};

export const reducer = persistReducer(
  {
    storage,
    key: "Fingerprint",
    whitelist: [
      "token",
      "user",
      "permissionList",
      "name",
      "surname",
      "username"
    ],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { token , permissionList,name,surname,username} = action.payload;
        return {
          token,
          permissionList,
          name,
          surname,
          username
        };
      }

      case actionTypes.Register: {
        const { token } = action.payload;

        return { token, user: undefined };
      }

      case actionTypes.Logout: {

        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user };
      }


      default:
        return state;
    }
  }
);

export const actions = {
  login: (token,permissionList,name,surname,username) => ({
    type: actionTypes.Login,
    payload: { token,permissionList,name,surname,username},
  }),
  register: (token) => ({
    type: actionTypes.Register,
    payload: { token },
  }),
  logout: () => ({
    type: actionTypes.Logout,
  }),

  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({
    type: actionTypes.UserLoaded,
    payload: { user },
  }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),


};

export function* saga() {

}
